import React, { useEffect, useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

const icon = (
    <CheckBoxOutlineBlankIcon fontSize="small" style={{ borderRadius: 4 }} />
);

const checkedIcon = (
    <CheckBoxIcon
        style={{ backgroundColor: "#FF5C39", color: "#fff", borderRadius: 4 }}
        fontSize="small"
    />
);
interface Option {
    id: number;
    value: string;
    label: string;
    groupBy: string;
}

interface NestedCheckboxListProps {
    options: Option[];
    value: Option[];
    setValue: (value: Option[]) => void;
    isMobile?: boolean;
}

const NestedCheckboxList: React.FC<NestedCheckboxListProps> = ({
    options,
    value,
    setValue,
    isMobile = true,
}) => {
    const [groupStates, setGroupStates] = useState<Record<string, boolean>>({});

    // Initialize group states on mount
    useEffect(() => {
        const initialGroupStates: Record<string, boolean> = {};

        const groups = Array.from(new Set(options.map((option) => option.groupBy)));
        groups.forEach((group) => {
            const childOptions = options.filter(
                (child) => child.groupBy === group && child.groupBy !== child.value
            );

            // If all children are selected, set the group as true; otherwise, false
            const allChildrenSelected = childOptions.every((child) =>
                value.some((item) => item.id === child.id)
            );
            initialGroupStates[group] = allChildrenSelected;
        });

        setGroupStates(initialGroupStates);
    }, [options, value]);

    // Handle group toggle logic
    const handleGroupToggle = (groupName: string) => {
        const isSelected = groupStates[groupName];

        const groupOptions = options.filter(
            (option) => option.groupBy === groupName && option.groupBy !== option.value
        );
        console.log(groupOptions)
        const newSelectedOptions = isSelected
            ? value.filter((item) => !groupOptions.some((child) => child.id === item.id))
            : [
                ...value,
                ...groupOptions.filter(
                    (child) => !value.some((item) => item.id === child.id)  // Only add group options that are not already in value
                ),
            ];;
        console.log(newSelectedOptions)
        setGroupStates((prev) => ({ ...prev, [groupName]: !isSelected }));
        setValue(newSelectedOptions);
    };

    // Handle individual checkbox toggle
    const handleOptionToggle = (option: Option) => {
        const isSelected = value.some((item) => item.id === option.id);

        const newSelectedOptions = isSelected
            ? value.filter((item) => item.id !== option.id)
            : [...value, option];

        setValue(newSelectedOptions);
        updateGroupStates(newSelectedOptions);
    };

    // Update group states dynamically
    const updateGroupStates = (currentValue: Option[]) => {
        const newGroupStates: Record<string, boolean> = {};

        const groups = Array.from(new Set(options.map((option) => option.groupBy)));

        groups.forEach((group) => {
            const childOptions = options.filter(
                (child) => child.groupBy === group && child.groupBy !== child.value
            );

            const allChildrenSelected = childOptions.every((child) =>
                currentValue.some((item) => item.id === child.id)
            );

            newGroupStates[group] = allChildrenSelected;
        });

        setGroupStates(newGroupStates);
    };

    return (
        <div>
            {Object.keys(groupStates).map((groupName) => (
                <>
                    {isMobile && <hr />}

                    <div key={groupName} style={{ marginBottom: '10px' }} className=' pl-1 pr-5'>
                        {/* Group checkbox */}

                        <span className='flex items-center gap-x-1'>
                            <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                checked={groupStates[groupName]}
                                sx={{ ml: 1 }}
                                // indeterminate={
                                //     options
                                //         .filter(
                                //             (child) =>
                                //                 child.groupBy === groupName && child.groupBy !== child.value
                                //         )
                                //         .some((child) => value.some((item) => item.id === child.id)) &&
                                //     !groupStates[groupName]
                                // }
                                onChange={() => handleGroupToggle(groupName)}
                            />
                            <p className='font-medium cursor-pointer' onClick={() => handleGroupToggle(groupName)}>{groupName}</p> <span className="ml-auto">
                                {/* <svg
                                    className='cursor-pointer'
                                    stroke="#FF5C39" fill="#FF5C39" strokeWidth="0" viewBox="0 0 16 16"
                                    height="20px" width="20px" xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path fillRule="evenodd" d="M8 15A7 7 0 108 1a7 7 0 000 14zm0 1A8 8 0 108 0a8 8 0 000 16z" clipRule="evenodd"></path>
                                    <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588z"></path>
                                    <circle cx="8" cy="4.5" r="1"></circle>
                                </svg> */}
                            </span></span>



                        {/* Child checkboxes */}
                        <div style={{ paddingLeft: '20px' }}>
                            {options
                                .filter(
                                    (option) =>
                                        option.groupBy === groupName && option.groupBy !== option.label
                                )
                                .map((child) => (
                                    <div key={child.id} style={{ marginBottom: '5px' }}>
                                        <Checkbox
                                        
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            checked={value.some((item) => item.id === child.id)}
                                            onChange={() => handleOptionToggle(child)}
                                            sx={{ ml: 1 }}
                                            inputProps={{ 'aria-label': child?.label }}
                                        
                                        />
                                        <span className='cursor-pointer' onClick={() => handleOptionToggle(child)} >{child.label}</span>
                                    </div>
                                ))}
                        </div>
                    </div>
                </>
            ))}
        </div>
    );
};

export default NestedCheckboxList;
